import {routeName as personalAccount} from "./routes/cabinet";
import {routeName as incoming} from "./routes/cabinet/incoming";
import {routeName as outgoing} from "./routes/cabinet/outgoing";
import {routeName as createDocument} from './routes/cabinet/create';
import {routeName as editDocument} from './routes/cabinet/edit';
import {routeName as documentInfo} from './routes/cabinet/info';
import {routeName as incomingDoc} from './routes/cabinet/incoming/doc';
import {routeName as outgoingDoc} from './routes/cabinet/outgoing/doc';
import {routeName as mainPage} from './routes/main';
import {routeName as externalDocPage} from './routes/externalDoc';
import {routeName as externalDocLinkPage} from './routes/externalDoc/link';
import {routeName as draftList} from './routes/cabinet/draft';
import {routeName as draftDocument} from './routes/cabinet/draft/doc';
import {routeName as trashDocument} from './routes/cabinet/trash';
import {routeName as cabinetTariffs} from './routes/cabinet/tariffs';
import {routeName as mainValidate} from './routes/validate';

export const pages = {
    personalAccount,
    incoming,
    outgoing,
    createDocument,
    editDocument,
    documentInfo,
    mainPage,
    externalDocPage,
    externalDocLinkPage,
    draftList,
    draftDocument,
    trashDocument,
    cabinetTariffs,
    mainValidate,
    incomingDoc,
    outgoingDoc,
} as const;
